export const PRIMARY_LOCALE = 'de'

export interface FieldConfig<T> {
  key: string
  weight?: number
  isComplete: (entity: T, primaryLocale: string) => boolean
}

export interface SectionConfig<T> {
  id: string
  labelKey: string
  editRouteName: string
  fields: FieldConfig<T>[]
}

export interface SectionCompletion {
  id: string
  labelKey: string
  editRouteName: string
  percentage: number
}

export interface CompletionResult {
  sections: SectionCompletion[]
  total: number
}

type Translation = { locale: string; value?: string | null }

export const hasText = (value: string | null | undefined): boolean => typeof value === 'string' && value.trim().length > 0

export const hasItems = (value: readonly unknown[] | null | undefined): boolean => Array.isArray(value) && value.length > 0

export const hasTranslationValue = (translations: readonly Translation[] | null | undefined, locale: string): boolean =>
  !!translations?.some((translation) => translation.locale === locale && hasText(translation.value))

export const isAnswered = (value: unknown): boolean => value !== null && value !== undefined && String(value) !== 'no_info'
